// ---------------------------------------------------------------------------
// ผู้ให้บริการส่งใบกำกับภาษีอิเล็กทรอนิกส์เข้ากรมสรรพากร — ยังไม่ได้ต่อ (stub)
// ---------------------------------------------------------------------------
// การส่งจริงต้องมี ผู้ให้บริการ e-Tax Invoice by Email / Service Provider ที่ได้รับอนุญาต + ใบรับรองดิจิทัลของร้าน
// ตอนนี้ระบบออกเลข/เก็บ/พิมพ์เอกสารได้ แต่ "ยังไม่ได้ส่งกรมสรรพากร" — หน้าจอจึงซ่อนปุ่มส่งจริงไว้
// เมื่อต่อผู้ให้บริการ: ทำ submit() ให้คืน { status: "queued", providerRef } แล้ว isConfigured() = true
// ---------------------------------------------------------------------------

export const etaxProvider = {
  name: "",
  isConfigured: () => false,
  submit: async () => ({
    status: "not_configured",
    message: "ยังไม่เชื่อมต่อผู้ให้บริการ e-Tax — ออก/พิมพ์เอกสารได้ แต่ยังไม่ส่งกรมสรรพากร",
  }),
};
